import { render, staticRenderFns } from "./XMark.vue?vue&type=template&id=4c71cc0d"
import script from "./XMark.vue?vue&type=script&lang=js"
export * from "./XMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports